import clsx from 'clsx';

interface PostcardJumboProps {
  className?: string;
}

const PostcardJumbo: React.FC<PostcardJumboProps> = ({ className }) => {
	return (
		<svg
			className={clsx('postcard-jumbo', className)}
			fill="none"
			height="96"
			viewBox="0 0 164 96"
			width="164"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M8 0.5H156C160.142 0.5 163.5 3.85786 163.5 8V88C163.5 92.1421 160.142 95.5 156 95.5H8C3.85787 95.5 0.5 92.1421 0.5 88V8C0.5 3.85786 3.85786 0.5 8 0.5Z"
				fill="white"
			/>
			<path
				d="M8 0.5H156C160.142 0.5 163.5 3.85786 163.5 8V88C163.5 92.1421 160.142 95.5 156 95.5H8C3.85787 95.5 0.5 92.1421 0.5 88V8C0.5 3.85786 3.85786 0.5 8 0.5Z"
				stroke="#D1D2D4"
			/>
			<rect fill="#D0E3FC" height="80" width="148" x="8" y="8" />
			<path
				d="M77.5 48C79.1569 48 80.5 46.6569 80.5 45C80.5 43.3431 79.1569 42 77.5 42C75.8431 42 74.5 43.3431 74.5 45C74.5 46.6569 75.8431 48 77.5 48Z"
				fill="#73AAF6"
			/>
			<path
				d="M83.5 44.25C83.5 43.8358 83.8358 43.5 84.25 43.5H90.25C90.6642 43.5 91 43.8358 91 44.25C91 44.6642 90.6642 45 90.25 45H84.25C83.8358 45 83.5 44.6642 83.5 44.25Z"
				fill="#73AAF6"
			/>
			<path
				d="M83.5 48C83.5 47.5858 83.8358 47.25 84.25 47.25H90.25C90.6642 47.25 91 47.5858 91 48C91 48.4142 90.6642 48.75 90.25 48.75H84.25C83.8358 48.75 83.5 48.4142 83.5 48Z"
				fill="#73AAF6"
			/>
			<path
				d="M85 51.75C85 51.3358 85.3358 51 85.75 51H90.25C90.6642 51 91 51.3358 91 51.75C91 52.1642 90.6642 52.5 90.25 52.5H85.75C85.3358 52.5 85 52.1642 85 51.75Z"
				fill="#73AAF6"
			/>
			<path
				d="M73 39C71.3431 39 70 40.3431 70 42V54C70 55.6569 71.3431 57 73 57H91C92.6569 57 94 55.6569 94 54V42C94 40.3431 92.6569 39 91 39H73ZM71.5 42C71.5 41.1716 72.1716 40.5 73 40.5H91C91.8284 40.5 92.5 41.1716 92.5 42V54C92.5 54.8284 91.8284 55.5 91 55.5H83.4392C83.4793 55.255 83.5 55.0046 83.5 54.75C83.5 51.8505 80.8137 49.5 77.5 49.5C74.3705 49.5 71.8007 51.5964 71.5246 54.2718C71.5084 54.1836 71.5 54.0928 71.5 54V42Z"
				fill="#73AAF6"
			/>
		</svg>
	);
};


export default PostcardJumbo;
